<template>
    <table class="table">
        <thead>
        <tr>
            <th scope="col" style="padding-left: 20px;">{{ $t('reviews.text_16') }}</th>
            <th scope="col">{{ $t('reviews.text_17') }}</th>
            <th scope="col" style="width: 25%;">{{ $t('reviews.text_18') }}</th>
            <th scope="col" style="width: 50%;">{{ $t('reviews.text_19') }}</th>
            <th scope="col">{{ $t('reviews.text_20') }}</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="review in myreviews" :key="review.id">
                <th scope="row">{{review.id}}</th>
                <td>{{review.klient}}</td>
                <td  style="white-space: normal;">
                    {{review.osoba}}
                </td>
                <td>
                    <p style="white-space: normal; width: 90%; ">
                        {{review.text}}
                    </p>
                </td>
                <td style="position: relative; display: flex; align-items: center;">
                    <a v-if="!review.active" :title="$t('reviews.text_21')" class="my_tooltip m-r-15" >
                        <span class="my_tooltiptext">{{ $t('reviews.text_21') }}</span>
                        <i @click="de_active(1,review.id)" class="fa fa-eye f-w-600 f-16 text-success"></i>
                    </a>
                    <a v-if="review.active" :title="$t('reviews.text_22')" class="my_tooltip m-r-15">
                        <span class="my_tooltiptext">{{ $t('reviews.text_22') }}</span>
                        <i @click="de_active(0,review.id)" class="fa fa-eye-slash f-w-600 f-16 text-danger"></i>
                    </a>
                    <a :title="$t('reviews.text_23')" class="my_tooltip m-r-15">
                        <span class="my_tooltiptext">{{ $t('reviews.text_23') }}</span>
                        <i @click="$emit('editReview',review)" class="icon feather icon-edit f-w-600 f-16 text-c-green"></i>
                    </a>
                    <a :title="$t('reviews.text_24')" class="my_tooltip m-r-15">
                        <span class="my_tooltiptext">{{ $t('reviews.text_24') }}</span>
                        <i @click="remove(review.id)" class="fa fa-trash-o f-w-600 f-16 text-danger"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: ['reviews','newReview'],
        data() {
            return {
                myreviews: null
            }
        },
        methods: {
            remove(id){
                var data = {}
                this.myreviews.forEach(r => {
                    if(r.id == id){
                        data = r
                    }
                });
                this.myreviews = this.myreviews.filter(function(item) {
                    return item !== data
                })
                data['delete'] = true
                axios
                .post(`/api/reviews`, data)
                .then(response => {
                    this.$toast.success(this.$t('reviews.text_25'), { timeout: 3038, });
                })
            },
            de_active(type,id) {
                if(type == 0){
                    var text = this.$t('reviews.text_26');
                } else {
                    var text = this.$t('reviews.text_27');
                }
                var data = {}
                this.myreviews.forEach(r => {
                    if(r.id == id){
                        r.active = type
                        data = r
                    }
                });
                data['edit'] = true
                axios
                .post(`/api/reviews`, data)
                .then(response => {
                    this.$toast.success(text, { timeout: 3038, });
                })
            }
        },
        created () {
            this.myreviews = this.reviews
        },
        watch: {
            newReview: function(){
                if(this.newReview){
                    axios
                    .get(`/api/reviews`)
                    .then(response => {
                        this.myreviews = response.data
                        this.$emit('changeReview', false)
                    })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .my_tooltip{
        cursor: pointer;
    }
    .table > thead > tr{
        border-bottom: 1px solid #dee2e6;
    }
    .table > thead > tr > th{
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        padding: 1.3rem .5rem;
        border-bottom: none;
    }
    .table > tbody > tr {
        border-top: none;
        border-bottom: 1px solid #dee2e6;
        th{
            padding: 1.3rem .5rem;
            padding-left: 20px;
        }
        td{
            padding: 1.3rem .5rem;
        }
    }
</style>    